<template lang="pug">
  div.school-list
    portal(to='toolbar')
      v-toolbar-title Driving Schools
    v-data-table(
      :headers="headers"
      :items="list"
      item-key="ID"
      hide-default-footer
      :disable-sort="true"
      :server-items-length="list.length"
      :loading="loading"
      hide-default-header=true
    )

      template(v-slot:top="props")
        div.totals
          p.totals-count Total candidates count:
           b  {{ total_count }}
          p.totals-paid Total paid amount:
           b  {{ total_paid }} (€)
          .d-flex.justify-between
            search(:value="searchValue" @change="search" placeholder='Search by name').mr-2
            driving-school-create(@create="$emit('needToUpdate')")
              template(v-slot="create")
                v-dialog(
                  max-width="400px"
                  :value="create.showing"
                  @input="create.updateShowing"
                )
                  template(v-slot:activator="{on}")
                    v-btn(outlined color="primary" @click="create.toggle") add
                  v-card
                    v-card-title Add driving school
                    v-divider
                    v-card-text
                      driving-school-body(
                        :formData="create.formData"
                        :formErrors="create.formErrors"
                        @update="create.updateFormData"
                      )
                    v-divider
                    v-card-actions
                      v-spacer
                      v-btn(@click="create.toggle" color="primary" outlined) cancel
                      v-btn(@click="create.checkValidatorBeforeSend(create.formData)"  color="primary") add

      template(v-slot:header="{ props }")
        tr
          th(v-for="(header, index) in props.headers" :key="index").border-right.text-center {{ header.text }}

      template(v-slot:item="{item}")
        driving-school-list-item(:item="item" @remove="$emit('remove', $event)")

</template>

<script>
import DrivingSchoolListItem from './DrivingSchoolListItem.vue'
import { fields } from '../core/const'
import DrivingSchoolCreate from "./DrivingSchoolCreate.vue"
import DrivingSchoolBody from "./DrivingSchoolBody.vue"

export default {
  props: {
    searchValue: {
      type: String,
    },
    list: {
      type: Array,
      required: true
    },
    total_paid: {
      type: [String, Number],
      required: true,
    },
    total_count: {
      type: [String, Number],
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    DrivingSchoolListItem,
    search: () => import('@/components/global/Search.vue'),
    DrivingSchoolCreate,
    DrivingSchoolBody
  },
  methods: {
    search(value) {
      this.$emit('search', value)
    }
  },
  data: () => ({
    headers: [
      { text: 'Driving School', value: fields.DRIVING_SCHOOL, sortable: false, align: 'center' },
      { text: 'Slug', value: fields.SLUG, sortable: false, align: 'center' },
      { text: 'Driving School Number', value: fields.DRIVING_SCHOOL_NUMBER, sortable: false, align: 'center' },
      { text: 'Candidates Count', value: fields.COUNT, sortable: false, align: 'center' },
      { text: 'Paid (€)', value: fields.PAID, sortable: false, align: 'center' },
      { text: 'Count from total (%)', value: fields.PCT_FROM_TOTAL_COUNT, sortable: false, align: 'center' },
      { text: 'Paid from total (%)', value: fields.PCT_FROM_TOTAL_PAID, sortable: false, align: 'center' },
      { text: '', value: '-', sortable: false, align: 'center' },
    ],
  }),
}
</script>


<style lang="scss" scoped>

  .border-right{
    border-right: 1px solid $border-color;
    border-bottom: 1px solid $border-color;
    &:last-child {
      border-right: unset;
    }
  }

  .totals{
    padding: 16px;
    border-bottom:1px solid $border-color;
  }

</style>